import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-overlay-background',
    templateUrl: './overlay-background.component.html'
})
export class OverlayBackgroundComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}

}
